import * as Actions from './ActionTypes'
import axios from 'axios'
export const addIngredient=ingtype=>{
    return{
        type:Actions.ADD_INGREDIENT,
        payload:ingtype
    }
}

export const removeIngredient=ingtype=>{
    return{
        type:Actions.REMOVE_INGREDIENT,
        payload:ingtype
    }
}

export const updatePrice=()=>{
    return {type:Actions.UPDATE_PRICE}
}

export const resetIngredient=()=>{
    return {type:Actions.RESET_INGREDIENT}
}

export const LoadOrders=orders=>{
    return{
        type:Actions.LOAD_ORDERS,
        payload:orders
    }
}
export const LoadOrderFailed=()=>{
    return{
        type:Actions.LOAD_ORDERS_FAILED
    }
}

export const fetchOrder=(token,userId)=>dispatch=>{
        // const queryParams='&orderBy="userId"&equalTo="'+userId+'"';
        const queryParams= '&orderBy="userId"&equalTo="' + userId + '"';
        axios.get('https://burger-builder-3abd7-default-rtdb.firebaseio.com/orders.json?auth='+token+queryParams)
        .then(response=>response.data)
        .then(orders=>dispatch(LoadOrders(orders)))
        .catch(()=>dispatch(LoadOrderFailed()))

        
}